// extracted by mini-css-extract-plugin
export var chevron = "_jp-4";
export var chevronExpanded = "_jp-5";
export var row = "_jp-0";
export var rowBody = "_jp-6";
export var rowDescription = "_jp-7";
export var rowHeader = "_jp-1";
export var rowTitle = "_jp-2";
export var rowTitleComplete = "_jp-3";